var vs = require("../../assets/imgs/banklogo.png");
const app = {
  state: {
    BankLogo: vs,
    PageSize: [{
        key: "5"
      },
      {
        key: "10"
      },
      {
        key: "15"
      },
      {
        key: "20"
      },
      {
        key: "100"
      },
      {
        key: "ALL"
      }
    ],
    Agrementdate: "23rd August 2017",
    AstonAgrementdate: "21st August 2017",
  },
  getters: {
    PageSize: state => state.PageSize,
    //AGREEMENTDATE: (state) => state.Agrementdate,
    GETBANKLOGO: (state) => state.BankLogo,
    GETAGGREMENTDATE: state => state.Agrementdate,
    GETASTONAGGREMENTDATE: state => state.AstonAgrementdate
  }
};

export default app;